export default __webpack_public_path__ + "static/media/icon-slider.cbca35e0.svg";